var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.62 22.75c-3.78 0-6.75-2.38-7.57-6.07l-.41-1.86c-.28-1.28.45-2.66 1.66-3.15l6.93-2.78a4.81 4.81 0 0 1 3.54 0l6.93 2.78c1.22.49 1.95 1.87 1.66 3.15l-.41 1.86c-.82 3.69-3.79 6.07-7.57 6.07H9.62zm1.16-12.47-6.93 2.78c-.53.21-.88.88-.76 1.43l.41 1.86c.67 3.02 3.01 4.89 6.11 4.89h4.76c3.1 0 5.44-1.87 6.11-4.89l.41-1.86c.12-.55-.23-1.22-.76-1.43l-6.93-2.78a3.282 3.282 0 0 0-2.42 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22V10c0-.41.34-.75.75-.75s.75.34.75.75v12c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.72 12.5-5.51-2.21a3.29 3.29 0 0 0-2.43 0L5.27 12.5a.76.76 0 0 1-.7-.08.738.738 0 0 1-.33-.62V8c0-2.07 1.68-3.75 3.75-3.75h8c2.07 0 3.75 1.68 3.75 3.75v3.8c0 .25-.12.48-.33.62-.12.09-.26.13-.41.13-.09 0-.19-.02-.28-.05zm-4.95-3.61 4.48 1.8V8c0-1.24-1.01-2.25-2.25-2.25H8C6.76 5.75 5.75 6.76 5.75 8v2.69l4.48-1.8c.57-.22 1.17-.34 1.77-.34.6 0 1.2.11 1.77.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.75c-.41 0-.75-.34-.75-.75V3c0-.96.79-1.75 1.75-1.75h3c.96 0 1.75.79 1.75 1.75v2c0 .41-.34.75-.75.75h-5zm4.25-1.5V3c0-.14-.11-.25-.25-.25h-3c-.14 0-.25.11-.25.25v1.25h3.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineShip);
export default __webpack_public_path__ + "static/media/vuesax-outline-ship.9a5a84f751f1bc195785dee54896bd78.svg";
export { ForwardRef as ReactComponent };